import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class ContactService {
    static getContacts(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.getPaginated(`contacts?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.contact.createdOn = parseDate(x.contact.createdOn);
                x.contact.updatedOn = parseDate(x.contact.updatedOn);
            });
            return w;
        }));
    }
    static fetchContact(oid) {
        return BaseService.get(`contacts/${oid}`).pipe(map(x => {
            x.payload.createdOn = parseDate(x.payload.createdOn);
            x.payload.updatedOn = parseDate(x.payload.updatedOn);
            return x;
        }));
    }
    static saveContact(dto) {
        return BaseService.save(`contacts`, dto);
    }
    static deleteContact(oid) {
        return BaseService.delete(`contacts/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Comments
    // ----------------------------------------------------------------------
    static getContactComments(contactId) {
        return BaseService.get(`contact-comments/${contactId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveContactComment(dto) {
        return BaseService.post(`contact-comments`, dto);
    }
    static deleteContactComment(oid) {
        return BaseService.delete(`contact-comments/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Channels
    // ----------------------------------------------------------------------
    static getContactChannels(contactId) {
        return BaseService.get(`contact-channels/${contactId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveContactChannel(dto) {
        return BaseService.post(`contact-channels`, dto);
    }
    static deleteContactChannel(oid) {
        return BaseService.delete(`contact-channels/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Companies
    // ----------------------------------------------------------------------
    static getContactCompanies(companyId) {
        return BaseService.get(`contact-companies/${companyId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    // public static saveCompanyContact(dto: ICompanyContact) {
    //   return BaseService.save<ICompanyContact>(`contact-companies`, dto);
    // }
    // public static deleteCompanyContact(oid: number) {
    //   return BaseService.delete<IEmptyDTO>(`contact-companies/${oid}`);
    // }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchContactCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`contacts-combo/${selfId}?search=${qs}`);
    }
}
